import * as React from 'react'
import cn from 'classnames'
import { defineMessages, FormattedMessage } from 'react-intl'
import FeatureGrid from '../../../../components/feature-grid'
import styles from './whatYouGet.module.scss'

const messages = defineMessages({
  title: {
    defaultMessage: 'Hur vi skiljer oss från andra bokföringsbyråer',
    id: 'start.differences.title',
  },
  feature1Title: {
    defaultMessage: 'Personlig senior ekonom',
    id: 'start.differences.feature1.title',
  },
  feature1Lede: {
    defaultMessage: 'Som gör din bokföring med hjälp av smart teknik samt svarar på alla dina frågor.',
    id: 'start.differences.feature1.lede',
  },
  feature2Title: {
    defaultMessage: 'Redovisning',
    id: 'start.differences.feature2.title',
  },
  feature2Lede: {
    defaultMessage: 'Allt du gör är att fota och skicka in ditt material så gör Dooer all din bokföring.',
    id: 'start.differences.feature2.lede',
  },
  feature3Title: {
    defaultMessage: 'Full transparens',
    id: 'start.differences.feature3.title',
  },
  feature3Lede: {
    defaultMessage: 'Din bokföring och allt ditt material är alltid uppdaterat och tillgängligt.',
    id: 'start.differences.feature3.lede',
  },
  feature4Title: {
    defaultMessage: 'Rapporter',
    id: 'start.differences.feature4.title',
  },
  feature4Lede: {
    defaultMessage: 'Alla dina rapporter är alltid uppdaterade och finns att ladda ner precis när du vill.',
    id: 'start.differences.feature4.lede',
  },
  feature5Title: {
    defaultMessage: 'Webb och mobilapp',
    id: 'start.differences.feature5.title',
  },
  feature5Lede: {
    defaultMessage: 'Du sköter allt gällande ditt företag på webben eller i telefonen.',
    id: 'start.differences.feature5.lede',
  },
  feature6Title: {
    defaultMessage: 'Kom-igång-hjälp',
    id: 'start.differences.feature6.title',
  },
  feature6Lede: {
    defaultMessage: 'Vi hjälper dig komma igång med Dooer och ser till så du vet precis hur allt funkar.',
    id: 'start.differences.feature6.lede',
  },
})

const features = [
  {
    title: messages.feature1Title,
    text: messages.feature1Lede,
  },
  {
    title: messages.feature2Title,
    text: messages.feature2Lede,
  },
  {
    title: messages.feature3Title,
    text: messages.feature3Lede,
  },
  {
    title: messages.feature4Title,
    text: messages.feature4Lede,
  },
  {
    title: messages.feature5Title,
    text: messages.feature5Lede,
  },
  {
    title: messages.feature6Title,
    text: messages.feature6Lede,
  },
]

export default function WhatYouGet({
  variant,
  tight,
  cols,
}: {
  variant?: 'regular' | 'inverted'
  tight?: boolean
  cols?: 1 | 2 | 3
}) {
  return (
    <div className={cn(styles.root, variant === 'inverted' && styles.rootInverted, tight && styles.tight)}>
      <FormattedMessage
        defaultMessage="Detta får du med Dooer"
        id="sync-bank.components.what-you-get.heading"
        tagName="h2"
      />
      <FeatureGrid cols={cols} features={features} />
    </div>
  )
}
